<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getDeptsData)" class="refresh-btn">刷新</el-button>
    <div class="storemanage">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-input v-model="searchForm.deptName" placeholder="请输入医馆名称" />
          </el-form-item>
          <el-form-item label="医馆地址">
            <el-input v-model="searchForm.deptAddress" placeholder="请输入地址关键字" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getDeptsData, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getDeptsData, { deptName: null, deptAddress: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addDept">新增医馆</el-button>
        <!-- <el-button icon="el-icon-delete" type="danger" @click="deleteDeptList">批量删除</el-button> -->
        <!-- <a class="ml10" href="https://jingweidu.bmcx.com/" target="_blank">查询经纬度</a> -->
      </div>
      <!-- 医馆列表 -->
      <el-table v-loading="loading" border :data="deptList" ref="multipleTable" :max-height="tableHeight"
        @selection-change="val => $handleSelectionChange(val, true)">
        <!-- <el-table-column type="selection" width="50"/> -->
        <el-table-column type="index" label="序号" width="50" fixed="left" />
        <el-table-column prop="deptName" label="医馆简称" min-width="80" fixed="left" />
        <el-table-column prop="businessLicenseName" label="执照名称" min-width="150" />
        <el-table-column prop="phone" label="联系电话" min-width="120" />
        <el-table-column prop="standbyPhone" label="备用电话" min-width="120" />
        <el-table-column prop="deptAddress" label="医馆地址" min-width="300" />
        <el-table-column prop="status" label="医馆状态" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.status == '0' ? '正常' : '停用' }}
          </template>
        </el-table-column>
        <el-table-column prop="deptImg" label="医馆形象" min-width="160">
          <template slot-scope="scope">
            <el-image v-model="scope.row.deptImg" :src="scope.row.deptImg" fit="contain" />
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="160" />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editDept(scope.row)">编辑</el-button>
            <!-- <el-button icon="el-icon-delete" type="danger" @click="deleteDept(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="deptEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="960px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" label-width="150px" :rules="editFormRules" inline>
          <el-form-item label="所属公司" prop="companyId">
            <el-radio-group v-model="editForm.companyId" disabled>
              <el-radio :label="10">杏林春堂</el-radio>
              <el-radio :label="76">杏林诊所</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="执照名称" prop="businessLicenseName">
            <el-input v-model="editForm.businessLicenseName" placeholder="请输入医馆名称" />
          </el-form-item>
          <el-form-item label="门店简称" prop="deptName">
            <el-input v-model="editForm.deptName" placeholder="请输入门店简称" />
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="editForm.phone" placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="备用电话" prop="standbyPhone">
            <el-input v-model="editForm.standbyPhone" placeholder="请输入备用电话" />
          </el-form-item>
          <el-form-item label="显示顺序" prop="orderNum">
            <el-input-number v-model="editForm.orderNum" :min="1" />
          </el-form-item>
          <el-form-item label="门店编码" prop="deptCode">
            <el-input v-model="editForm.deptCode" placeholder="请输入门店编码" />
          </el-form-item>
          <el-form-item label="社保医疗机构编码" prop="socialDeptCode">
            <el-input v-model="editForm.socialDeptCode" placeholder="请输入国家医保代码" />
          </el-form-item>
          <el-form-item label="国家医保代码" prop="ybDeptNum">
            <el-input disabled v-model="editForm.ybDeptNum" placeholder="请输入国家医保代码" />
          </el-form-item>
          <el-form-item label="门店形象" prop="deptImg" class="imgwrap">
            <el-upload :on-success="handleImgSuccess" :action="uploadUrl" list-type="picture-card" :limit="1" :on-exceed="handleExceed"
              :on-remove="handleRemove" :data="{ storagePath: 'picture' }" :file-list="fileList" name="files"
              accept="image/*" :with-credentials="true">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="所属区域" prop="deptAddress">
            <el-cascader ref="regionCascader" class="form_input" v-model="editForm.area" :props="{ label: 'areaName', value: 'areaCode' }" :options="areaList" placeholder="请选择省/市/区县" @change="areaChange"></el-cascader>
            <!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" resize="none" v-model="editForm.deptAddress" placeholder="请输入医馆地址" /> -->
          </el-form-item>
          <el-form-item label="门店地址" prop="deptAddress">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" resize="none" v-model="editForm.deptAddress"
              placeholder="请输入医馆地址" />
          </el-form-item>
          <el-form-item label="门店状态">
            <el-radio-group v-model="editForm.status">
              <el-radio :label="'0'">正常</el-radio>
              <el-radio :label="'1'">停用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="地址经度" prop="longitude">
            <el-input v-model="editForm.longitude" placeholder="请在下方地图查询经度">
              <template slot="append"><a class="ml10" href="https://lbs.qq.com/getPoint/#S"
                  target="_blank">查询经纬度</a></template>
            </el-input>
          </el-form-item>
          <el-form-item label="地址纬度" prop="latitude">
            <el-input v-model="editForm.latitude" placeholder="请在下方地图查询纬度" />
          </el-form-item>
          <el-form-item label="停车指引" prop="guidance" class="imgwrap">
            <el-upload :on-success="guidanceImgSuccess" :action="uploadUrl" list-type="picture-card" :limit="1" :on-exceed="handleExceed"
              :on-remove="guidanceRemove" :data="{ storagePath: 'picture' }" :file-list="guidanceFileList" name="files"
              accept="image/*" :with-credentials="true">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="开启自助开发票功能" prop="defaultInvoiceStatus">
            <el-radio-group v-model="editForm.defaultInvoiceStatus">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="开启自助续方功能" prop="formulaStatus">
            <el-radio-group v-model="editForm.formulaStatus" :disabled="editForm.companyId == 76">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="realNameSwitch_box">
            <el-form-item label="开启实名制就医功能" prop="realNameSwitch" >
              <el-radio-group v-model="editForm.realNameSwitch">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="小程序是否展示" prop="clientStatus">
            <el-radio-group v-model="editForm.clientStatus" :disabled="editForm.companyId == 76">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div>
            <el-form-item label="配方区数量" prop="recipeAreasNum">
              <el-input-number v-model="editForm.recipeAreasNum" :min="1" />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="床位总数量" prop="bedTotalNumber">
              <el-input-number v-model="editForm.bedTotalNumber" :min="1" />
            </el-form-item>
          </div>
          <el-form-item label="营业时间" class="businessTime">
            <div class="businessTime_content">
              <div v-for="(businessRow, businessRowIndex) in businessTimeList" :key="`businessRow_${businessRowIndex}`" class="businessTime_row">
                <div v-for="businessItem in businessRow" :key="businessItem.id" class="businessTime_item">
                  <div class="businessTime_week">{{ businessItem.week }}</div>
                  <div class="businessTime_time">
                    <el-form-item class="businessTime_time_form_item" :prop="`businessTimeMap[${businessItem.key}].startTime`" :rules="{ validator: validateBusinessStartTime, key: businessItem.key, trigger: 'change' }" :show-message="false">
                      <el-time-select
                        class="businessTime_time_select"
                        v-model="editForm.businessTimeMap[businessItem.key].startTime"
                        :picker-options="businessTimePickerOptions"
                        value-format="hh:mm"
                        :clearable="false"
                        placeholder="开始">
                      </el-time-select>
                    </el-form-item>
                    <div class="businessTime_time_line">-</div>
                    <el-form-item class="businessTime_time_form_item" :prop="`businessTimeMap[${businessItem.key}].endTime`" :rules="{ validator: validateBusinessEndTime, key: businessItem.key, trigger: 'change' }" :show-message="false">
                      <el-time-select
                        class="businessTime_time_select"
                        v-model="editForm.businessTimeMap[businessItem.key].endTime"
                        :picker-options="businessTimePickerOptions"
                        value-format="hh:mm"
                        :clearable="false"
                        placeholder="结束">
                      </el-time-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="库存取值方式" prop="stockType">
            <el-radio-group v-model="editForm.stockType" style="width: 280px;" :disabled="editForm.companyId == 10" @input="stockTypeChange">
              <el-radio :label="1">取本门店库存</el-radio>
              <el-radio :label="2">取其他门店库存</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="mapDeptCode" v-if="editForm.stockType == 2">
            <el-input v-model="editForm.mapDeptCode" placeholder="请输入取其他门店编码" />
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button v-if="dialogTitle == '编辑医馆'" type="success" @click="editSave">保存修改</el-button>
          <el-button v-else-if="dialogTitle == '新增医馆'" type="success" @click="addSave">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getDeptsData)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
  </div>
</template>
<script lang="js">
import { deptList, deptEdit, deptDelete, deptAdd, deptInfo, getDeptBusinessTime } from "@/api/hospital"; // 医馆
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { isEmptyArray, isNull } from "@/utils/validateBase";
import { provincesTree } from '@/api/region'
export default {
  name: "Dept",
  data() {
    var validateMapDeptCode = (rule, value, callback) => {
      if(value == this.editForm.deptCode){
        return callback(new Error('不能与当前门店编码一致'));
      }else{
        callback();
      }
    };
    return {
      loading: true,
      searchForm: { deptName: null, deptAddress: null }, //查询表单
      deptList: [], //医馆列表
      currentPage: 1, //当前页
      pageSize: 50, //显示条数
      total: 0, //总条数
      dialogVisible: false, // 修改新增模态框状态
      dialogTitle: null, // 模态框标题
      multipleSelection: [], //选项
      areaList: [],
      editForm: {
        businessTimeMap: {
          'monday': { startTime: '', endTime: '', weeklyDay: '1' },
          'tuesday': { startTime: '', endTime: '', weeklyDay: '2' },
          'wednesday': { startTime: '', endTime: '', weeklyDay: '3' },
          'thursday': { startTime: '', endTime: '', weeklyDay: '4' },
          'friday': { startTime: '', endTime: '', weeklyDay: '5' },
          'saturday': { startTime: '', endTime: '', weeklyDay: '6' },
          'sunday': { startTime: '', endTime: '', weeklyDay: '7' }
        }
      }, //新增医馆
      imgVisible: false, // 图片显示状态
      uploadUrl: this.$filePath + '/xl/upload/temp/file/upload', // 图片上传接口地址
      editFormRules: {
        businessLicenseName: [{ required: true, message: "执照名称不能为空", trigger: "blur" }],
        deptName: [{ required: true, message: "医馆名称不能为空", trigger: "blur" }],
        orderNum: [{ required: true, message: "医馆排列顺序不能为空" }],
        phone: [{ required: true, message: "电话号码不能为空", trigger: "blur" }, { min: 5, max: 12, message: "号码长度在5-12位，请核实！", trigger: "blur" }],
        standbyPhone: [{ min: 5, max: 12, message: "号码长度在5-12位，请核实后再试！", trigger: "blur" }],
        deptAddress: [{ required: true, message: "医馆地址不能为空", trigger: "blur" }],
        deptImg: [{ required: true, message: "医馆形象图不能为空" }],
        longitude: [{ required: true, message: "地址经度不能为空" }],
        latitude: [{ required: true, message: "地址纬度不能为空" }],
        deptCode: [{ required: true, message: "医馆编码不能为空" }],
        clientStatus: [{ required: true, message: "小程序是否展示不能为空" }],
        formulaStatus: [{ required: true, message: "开启自助续方功能不能为空" }],
        bedTotalNumber: [{ required: true, message: "床位总数量不能为空" }],
        companyId: [{ required: true, message: "所属公司不能为空" }],
        stockType: [{ required: true, message: "库存取值方式不能为空" }],
        mapDeptCode: [{ required: true, message: "其他门店编码不能为空" },{ validator: validateMapDeptCode, trigger: 'blur' }],
        realNameSwitch: [{ required: true, message: "开启实名制就医功能不能为空",trigger: 'change' }],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
      fileList: [],
      deptImages: [],//科室icon
      guidanceImages:[],
      guidanceFileList:[],
      businessTimePickerOptions: {
        start: '00:00',
        end: '24:00',
        step: '00:10'
      },
      businessTimeList: [
        [
          {
            id: 'monday',
            week: '周一',
            key: 'monday'
          },
          {
            id: 'tuesday',
            week: '周二',
            key: 'tuesday'
          },
          {
            id: 'wednesday',
            week: '周三',
            key: 'wednesday'
          },
          {
            id: 'thursday',
            week: '周四',
            key: 'thursday'
          }
        ],
        [
          {
            id: 'friday',
            week: '周五',
            key: 'friday'
          },
          {
            id: 'saturday',
            week: '周六',
            key: 'saturday'
          },
          {
            id: 'sunday',
            week: '周日',
            key: 'sunday'
          }
        ]
      ]
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getDeptsData();
    this.getAreaTree()
  },
  methods: {
    getAreaTree() {
      if(!sessionStorage.getItem('nationalAreaList')) {
        provincesTree().then(res => {
          if (res.code === 200) {
            this.areaList = res.data
            sessionStorage.setItem('nationalAreaList', JSON.stringify(res.data))
          }
        })
      } else {
        this.areaList = JSON.parse(sessionStorage.getItem('nationalAreaList'))
      }
    },
    validateBusinessStartTime (rule, value, callback) {
      if (![null, undefined, ''].includes(this.editForm.businessTimeMap[rule.key].endTime) && this.editForm.businessTimeMap[rule.key].startTime > this.editForm.businessTimeMap[rule.key].endTime) {
        callback(new Error('开始时间不能大于结束时间'))
      } else {
        callback()
      }
    },
    validateBusinessEndTime (rule, value, callback) {
      if (![null, undefined, ''].includes(this.editForm.businessTimeMap[rule.key].startTime) && this.editForm.businessTimeMap[rule.key].startTime > this.editForm.businessTimeMap[rule.key].endTime) {
        callback(new Error('开始时间不能大于结束时间'))
      } else {
        callback()
      }
    },
    // 请求所有医馆列表
    async getDeptsData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, userId: this.$session.get('user').userId, ...this.searchForm };
      let { total, rows, code } = await deptList(params);
      if (code == 200) {
        this.total = total;
        this.deptList = [0,-1].includes(this.$session.get('deptId')) ? rows : rows.filter(item => { return item.deptId == this.$session.get('deptId') })
      }
      this.loading = false;
    },
    // 新增医馆
    addDept() {
      this.dialogVisible = true;
      this.fileList = []
      this.dialogTitle = "新增医馆";
      this.editForm = {
        deptName: null,
        deptAddress: null,
        status: '0',
        deptImg: null,
        orderNum: null,
        phone: null,
        standbyPhone: null,
        businessLicenseName: null,
        longitude: null,
        latitude: null,
        defaultInvoiceStatus: 0,
        clientStatus:1,
        formulaStatus:1,
        recipeAreasNum:1,
        bedTotalNumber: 1,
        realNameSwitch: 0,
        businessTimeMap: {
          'monday': { startTime: '', endTime: '', weeklyDay: '1' },
          'tuesday': { startTime: '', endTime: '', weeklyDay: '2' },
          'wednesday': { startTime: '', endTime: '', weeklyDay: '3' },
          'thursday': { startTime: '', endTime: '', weeklyDay: '4' },
          'friday': { startTime: '', endTime: '', weeklyDay: '5' },
          'saturday': { startTime: '', endTime: '', weeklyDay: '6' },
          'sunday': { startTime: '', endTime: '', weeklyDay: '7' }
        },
        area: [],
        mapDeptCode:null,
        companyId: this.$session.get('user').companyId ,
        stockType:null
      };
      if(this.$session.get('user').companyId == 10){
        this.editForm.formulaStatus = 1
        this.editForm.clientStatus = 1
        this.editForm.stockType = 1
      }else{
        this.editForm.formulaStatus = 0
        this.editForm.clientStatus = 0
        this.editForm.stockType = null
      }
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate(async (valid) => {
        if (valid) {
          const businessTimeList =  []
          Object.keys(this.editForm.businessTimeMap).forEach(v => {
            if (this.editForm.businessTimeMap[v].startTime && this.editForm.businessTimeMap[v].endTime) {
              businessTimeList.push(this.editForm.businessTimeMap[v])
            }
          })
          this.editForm['deptWorkTimeConfigs'] = businessTimeList

          let obj = []
          this.deptImages.forEach(v => {
            obj.push({ uploadChannel: "deptImg", fileId: v.fileId, groupName: "group1", isNeedThumbnail: "2" })
          })
          this.guidanceImages.forEach(v => {
            obj.push({ uploadChannel: "guidanceImg", fileId: v.fileId, groupName: "group1", isNeedThumbnail: "2" })
          })
          if(this.editForm.stockType == 1){
            this.editForm.mapDeptCode = this.editForm.deptCode
          }
          let res = await uploadTemporaryFile(obj)
          if (res.errorCode == '0000') {
            this.fileList = [];
            this.deptImages = [];
            this.guidanceFileList = [];
            this.guidanceImages = [];
            res.data && res.data.forEach(v1=>{
              obj.forEach(v2=>{
                if(v1.fileId == v2.fileId && v2.uploadChannel == 'deptImg'){
                  this.editForm.deptImg = v1.fullPathUrl
                }
                if(v1.fileId == v2.fileId && v2.uploadChannel == 'guidanceImg'){
                  this.editForm.guidance = v1.fullPathUrl
                }
              })
            })
            deptAdd(this.editForm).then(res => {
              let { code } = res;
              if (code == 200){
                this.$message.success("新增医馆成功！");
                this.dialogVisible = false;
                this.$refresh(this.getDeptsData);
                this.$refs['editForm'].resetFields();
              }
            })
          } else {
            this.$message.error(res.errorMessage)
          }

        } else return false;
      })
    },
    // 删除医馆
    deleteDept(row) {
      this.$confirm('确认删除该医馆？').then(_ => { this.del(row.deptId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await deptDelete(id);
      if (code == 200) this.$message.success("删除医馆成功！");

      this.$refresh(this.getDeptsData);
    },
    // 医馆批量删除
    deleteDeptList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何医馆");
      else {
        selected.forEach(item => { selectedId.push(item.deptId) });
        this.$confirm('确认删除该医馆？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    },
    async getDeptTime(deptId) {
      const res = await getDeptBusinessTime({ deptId: deptId})
      if (res.code === 200) {
        const weeklyDayList = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        res.data.forEach(v => {
          const businessTimeKey = weeklyDayList[Number(v.weeklyDay) - 1]
          this.editForm.businessTimeMap[businessTimeKey].startTime = v.startTime
          this.editForm.businessTimeMap[businessTimeKey].endTime = v.endTime
        })
      }
    },
    // 编辑医馆
    async editDept(row) {
      let { data, code } = await deptInfo(row.deptId);
      if (code == 200) {
        data.orderNum = parseInt(data.orderNum);

        let area = []
        if (data.province && data.city && data.region) {
          area = [data.province, data.city, data.region]
        }

        this.editForm = {
          ...data,
          bedTotalNumber: ['', null].includes(data.bedTotalNumber) ? undefined : data.bedTotalNumber,
          defaultInvoiceStatus: data.defaultInvoiceStatus || 0,
          realNameSwitch: data.realNameSwitch || 0,
          businessTimeMap: {
            'monday': { startTime: '', endTime: '', weeklyDay: '1' },
            'tuesday': { startTime: '', endTime: '', weeklyDay: '2' },
            'wednesday': { startTime: '', endTime: '', weeklyDay: '3' },
            'thursday': { startTime: '', endTime: '', weeklyDay: '4' },
            'friday': { startTime: '', endTime: '', weeklyDay: '5' },
            'saturday': { startTime: '', endTime: '', weeklyDay: '6' },
            'sunday': { startTime: '', endTime: '', weeklyDay: '7' }
          },
          area: area,
          stockType: data.companyId == 10 ? 1 : (data.mapDeptCode == data.deptCode ? 1 : 2  ) 
        };
        this.dialogVisible = true;
        this.dialogTitle = "编辑医馆";
        if (data.deptImg) {
          this.fileList = [{ name: data.deptImg, url: data.deptImg }]
        }
        if (data.guidance) {
          this.guidanceFileList = [{ name: data.guidance, url: data.guidance }]
        }
        this.getDeptTime(row.deptId)
      }
    },
    // 保存医馆编辑
    editSave() {
      this.$refs['editForm'].validate(async (valid) => {
        if (valid) {
          const businessTimeList =  []
          Object.keys(this.editForm.businessTimeMap).forEach(v => {
            if (this.editForm.businessTimeMap[v].startTime && this.editForm.businessTimeMap[v].endTime) {
              businessTimeList.push(this.editForm.businessTimeMap[v])
            }
          })
          this.editForm['deptWorkTimeConfigs'] = businessTimeList
          let obj = []
          this.deptImages.forEach(v => {
            if (!isNull(v.fileId)) {
              obj.push({ uploadChannel: "deptImg", fileId: v.fileId, groupName: "group1", isNeedThumbnail: "2" })
            }
          })
          this.guidanceImages.forEach(v => {
            if (!isNull(v.fileId)) {
              obj.push({ uploadChannel: "guidanceImg", fileId: v.fileId, groupName: "group1", isNeedThumbnail: "2" })
            }
          })
          if(this.editForm.stockType == 1){
            this.editForm.mapDeptCode = this.editForm.deptCode
          }
          if (isEmptyArray(obj)) {
            deptEdit(this.editForm).then(res => {
              let { code } = res;
              if (code == 200) {
                this.$message.success("修改医馆信息成功！");
                this.dialogVisible = false;
                this.$refresh(this.getDeptsData);
                this.$refs['editForm'].resetFields();
              }
            })
          } else {
            let res = await uploadTemporaryFile(obj)
            if (res.errorCode == '0000') {
              this.fileList = [];
              this.deptImages = [];
              this.guidanceFileList = [];
              this.guidanceImages = [];
              res.data && res.data.forEach(v1=>{
                obj.forEach(v2=>{
                  if(v1.fileId == v2.fileId && v2.uploadChannel == 'deptImg'){
                    this.editForm.deptImg = v1.fullPathUrl
                  }
                  if(v1.fileId == v2.fileId && v2.uploadChannel == 'guidanceImg'){
                    this.editForm.guidance = v1.fullPathUrl
                  }
                })
              })
              deptEdit(this.editForm).then(res => {
                let { code } = res;
                if (code == 200){
                  this.$message.success("修改医馆信息成功！");
                  this.dialogVisible = false;
                  this.$refresh(this.getDeptsData);
                  this.$refs['editForm'].resetFields();
                }
              })
            } else {
              this.$message.error(res.errorMessage)
            }
          }
        } else return false;
      })
    },
    // 图片上传成功的函数
    handleImgSuccess(res, file, fileList) {
      console.log(88888888, res, file, fileList);
      if (res.errorCode == '0000') {
        this.deptImages.push(res.data[0])
        this.fileList = fileList
        this.editForm.deptImg = file.url
      }
    },
    handleRemove(res, file, fileList) {
      let fileId = res.response.data[0].fileId;
      this.deptImages = this.fileList.filter((item) => { return item.fileId != fileId })
    },
    handleExceed(){
      this.$message.warning('只能上传1张图片');
    },
    guidanceImgSuccess(res, file, fileList){
      if (res.errorCode == '0000') {
        this.guidanceImages.push(res.data[0])
        this.guidanceFileList = fileList
        this.editForm.guidance = file.url
      }
    },
    guidanceRemove(res, file, fileList){
      let fileId = res.response.data[0].fileId;
      this.guidanceImages = this.guidanceFileList.filter((item) => { return item.fileId != fileId })
    },
    guidanceExceed(){
      this.$message.warning('只能上传1张图片');
    },
    areaChange () {
      const area = this.$refs['regionCascader'].getCheckedNodes()[0]
      this.editForm['province'] = area.path[0]
      this.editForm['city'] = area.path[1]
      this.editForm['region'] = area.path[2]
      this.editForm['provinceName'] = area.pathLabels[0]
      this.editForm['cityName'] = area.pathLabels[1]
      this.editForm['regionName'] = area.pathLabels[2]
    },
    stockTypeChange(val){
      if(val == 2){
        this.editForm.mapDeptCode = ''
      }
    }
  },
};
</script>

<style lang="less" scoped>
.storemanage {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  .deptEdit {
    .el-form-item {
      width: 400px;
      margin-bottom: 10px !important;

      &.imgwrap {
        width: 96%;
        height: 148px;
        display: flex;

        /deep/.el-form-item__content {
          flex: 1;
        }
      }

      .el-input,
      .el-textarea,
      /deep/.el-form-item__content,
      /deep/.el-input-number {
        width: 250px;
      }
    }

    .img {
      width: 250px;
      height: 148px;
      position: relative;

      img {
        width: 250px;
        height: 148px;
      }

      &:hover .del {
        display: block;
      }
    }

    .del {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -10px 0 0 -10px;
      font-size: 18px;
      background-color: rgba(255, 255, 255, .75);
      border: 1px solid #F56C6C;
      color: #F56C6C;
      width: 20px;
      height: 20px;
      line-height: 16px;
      text-align: center;
      border-radius: 10px;
      display: none;
    }
  }
}

.el-image {
  width: auto;
  height: 60px;
  margin-top: 5px;
}

.businessTime {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100% !important;
}

.businessTime /deep/ .el-form-item__content {
  flex-grow: 1;
}

.businessTime_content {
  
}

.businessTime_row {
  display: flex;
  width: fit-content;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
}

.businessTime_row+.businessTime_row {
  margin: 8px 0 0 0;
}

.businessTime_item {
  width: 166px;
}

.businessTime_item+.businessTime_item {
  border-left: 1px solid #E0E0E0;
}

.businessTime_week {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  font-size: 14px;
  color: #667182;
  background-color: #F7F8F9;
}

.businessTime_time {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-top: 1px solid #E0E0E0;
}

.businessTime_time_form_item {
  width: fit-content !important;
}

.storemanage .deptEdit .businessTime_time_form_item {
  margin: 0 0 0 0 !important;
}

.businessTime_time_form_item /deep/ .el-form-item__content {
  width: fit-content !important;
}

.businessTime_time_select {
  width: 64px !important;
}

.businessTime_time_select /deep/ .el-input__inner {
  padding: 0 12px;
}

.businessTime_time_select /deep/ .el-input__prefix {
  display: none;
}

.businessTime_time_line {
  margin: 0 4px;
  color: #595F68;
}
</style>